/* eslint-disable func-names */
/* eslint-disable @typescript-eslint/dot-notation */
import { ProductType } from 'common/components/product-card/types';
import { GfData } from 'utils/dynamic-yields';
import { ProductPriceCategory } from 'features/products/types';

export const labelsGaNames = {
  PIM: 'onlineOnly',
  BPR: 'bestPrice',
  LOF: 'offerLimited',
  STD: 'discount',
};

export const isOnlineOnly = (product: ProductType) => product.source.toUpperCase() === 'PIM';
export const updateGFData = (gfData: GfData | undefined, priceCategory: ProductPriceCategory) => ({
  ...gfData,
  productTag: gfData?.productTag || labelsGaNames[priceCategory],
});

export const viewRRTracking = (impressionContentId: string) => {
  if (!window['rrApiOnReady']) window['rrApiOnReady'] = [];

  window['rrApiOnReady'].push(function () {
    try {
      window?.rrApi?.impressionContentViewed({
        impressionContentId,
      });
    } catch (e) {}
  });
};

export const clickRRTracking = (impressionContentId: string) => {
  if (!window['rrApiOnReady']) window['rrApiOnReady'] = [];

  window['rrApiOnReady'].push(function () {
    try {
      window?.rrApi?.impressionContentClicked({
        impressionContentId,
      });
    } catch (e) {}
  });
};
